var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverHorizontalstrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "METAL-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.75 16.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-14,.cls-18,.cls-19,.cls-2,.cls-20,.cls-27,.cls-28,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Sky_12);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#radial-gradient-2);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#Sky_12-2);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#radial-gradient-3);}.cls-25{fill:url(#radial-gradient-4);}.cls-26{fill:url(#Sky_12-3);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:#e5e1d8;}.cls-30{fill:#d9d5d2;}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 149.72,
    cy: -126.11,
    r: 9.46,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f3f3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d7dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dcd9d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 157.11,
    y1: -115.38,
    x2: 157.11,
    y2: -136.81,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b869f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7b869f",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7b869f",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7b869f",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7b869f",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b869f",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7b869f",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7b869f",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#7b869f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 142.28,
    y1: -121.55,
    x2: 157.5,
    y2: -136.77,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a8b5",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fffbe7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fffbe7",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fffbe7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fffbe7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 142.37,
    y1: -114.35,
    x2: 142.37,
    y2: -121.71,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12",
    x1: 144.24,
    y1: -122.93,
    x2: 155.12,
    y2: -122.93,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5adc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7b87a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 144.31,
    y1: -117.88,
    x2: 145.35,
    y2: -117.88,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 235.74,
    y1: 94.35,
    x2: 236.54,
    y2: 94.35,
    gradientTransform: "matrix(-0.72, -0.69, -0.69, 0.72, 247.68, 102.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 153.96,
    y1: -122.93,
    x2: 155.15,
    y2: -122.93,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 271.24,
    y1: 278.38,
    x2: 271.24,
    y2: 277.04,
    gradientTransform: "translate(286.47 289.27) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 27.03,
    y1: 5.97,
    x2: 27.03,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 150.68,
    y1: -173.77,
    x2: 149.56,
    y2: -174.89,
    gradientTransform: "matrix(0, 1, 1, 0, 187.81, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 149.72,
    cy: 151.93,
    r: 9.46,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 157.14,
    y1: 162.63,
    x2: 157.14,
    y2: 141.2,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 142.28,
    y1: 156.5,
    x2: 157.5,
    y2: 141.28,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 142.4,
    y1: 167.07,
    x2: 142.4,
    y2: 156.56,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12-2",
    x1: 144.24,
    y1: 155.12,
    x2: 155.12,
    y2: 155.12,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#Sky_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 144.26,
    y1: 160.16,
    x2: 145.45,
    y2: 160.16,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#545e74",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 34.54,
    y1: -97.57,
    x2: 35.35,
    y2: -97.57,
    gradientTransform: "translate(98.12 102.97) rotate(-43.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 153.99,
    y1: 155.12,
    x2: 155.15,
    y2: 155.12,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -57.82,
    y1: 278.42,
    x2: -57.82,
    y2: 277.05,
    gradientTransform: "matrix(1, 0, 0, -1, 110.34, 289.3)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 356.02,
    y1: 6.04,
    x2: 356.02,
    y2: 4.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 404.52, -0.97)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 150.82,
    y1: 155.36,
    x2: 149.6,
    y2: 154.14,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 156.42,
    cy: 172.34,
    r: 8.85,
    gradientTransform: "matrix(0, 1, -1.02, 0, 209.37, -141.71)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 143.01,
    cy: 172.34,
    r: 8.85,
    gradientTransform: "translate(-104.78 -174.24) scale(0.97 1.02)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12-3",
    x1: 144.24,
    y1: 175.09,
    x2: 155.13,
    y2: 175.09,
    gradientTransform: "translate(208.96 -141.71) rotate(90)",
    xlinkHref: "#Sky_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 153.96,
    y1: -102.97,
    x2: 155.15,
    y2: -102.97,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 144.26,
    y1: -102.97,
    x2: 145.36,
    y2: -102.97,
    gradientTransform: "matrix(0, 1, 1, 0, 136.84, -141.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 41.65,
    y1: 5.97,
    x2: 41.65,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 41.61,
    y1: 11.72,
    x2: 41.61,
    y2: 10.35,
    gradientTransform: "matrix(1, 0, 0, -1, -7.74, 22.6)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atk_Def_Panel_v1",
    "data-name": "Atk/Def Panel_v1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom_Frame",
    "data-name": "Bottom Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M21.44,0H14.72a.43.43,0,0,0-.32.14L.12,15.26A.45.45,0,0,0,.45,16h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M.74,16a1.16,1.16,0,0,1-.49,0,1,1,0,0,1-.18-.19l2.32-1H21.44V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M2.39,14.81,15.44,1.34,14.72,0s-.2,0-.26.07c-.27.31-.61.65-.61.65L.67,14.68a4.25,4.25,0,0,0-.6.66.39.39,0,0,0,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "15.44 1.34 14.72 0 21.44 0 21.44 1.34 15.44 1.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "21.44 2.52 16.47 2.54 6.37 13.41 21.44 13.41 21.44 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "21.44 3.71 17.07 3.71 16.47 2.54 21.44 2.52 21.44 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "6.37 13.4 16.47 2.53 17.07 3.71 9.02 12.23 6.37 13.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "21.44 12.23 9.02 12.23 6.37 13.41 21.44 13.41 21.44 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "21.44 12.23 9.02 12.23 17.07 3.71 21.44 3.71 21.44 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "12.13 10.89 21.44 10.89 21.44 12.23 9.02 12.23 12.13 10.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "21.44 5.04 17.86 5.04 17.07 3.71 21.44 3.71 21.44 5.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "9.02 12.23 17.07 3.71 17.86 5.04 12.13 10.89 9.02 12.23"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top_Frame",
    "data-name": "Top Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-13",
    d: "M46.31,0H53a.43.43,0,0,1,.32.14L67.63,15.26a.44.44,0,0,1-.32.75h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-14",
    d: "M67,16a1.21,1.21,0,0,0,.5,0,1.42,1.42,0,0,0,.18-.19l-2.32-1H46.31V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-15",
    d: "M65.37,14.81,52.31,1.34,53,0s.21,0,.26.07c.27.31.61.65.61.65l13.19,14a4.83,4.83,0,0,1,.6.66.39.39,0,0,1,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-16",
    points: "52.31 1.34 53.03 0 46.31 0 46.31 1.34 52.31 1.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-17",
    points: "46.31 2.52 51.29 2.54 61.38 13.41 46.31 13.41 46.31 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-18",
    points: "46.31 2.52 51.29 2.54 50.68 3.74 46.31 3.74 46.31 2.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-19",
    points: "61.38 13.41 51.29 2.53 50.68 3.73 58.73 12.26 61.38 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-20",
    points: "46.31 12.26 58.73 12.26 61.38 13.41 46.31 13.41 46.31 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "46.31 12.26 58.73 12.26 50.68 3.75 46.31 3.74 46.31 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-21",
    points: "55.4 10.9 46.31 10.88 46.31 12.26 58.73 12.26 55.4 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-22",
    points: "46.31 5.08 49.89 5.08 50.68 3.74 46.31 3.74 46.31 5.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "58.73 12.26 50.68 3.74 49.89 5.08 55.4 10.9 58.73 12.26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-3",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 21.2,
    y: 13.41,
    width: 25.34,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 32.61,
    y: -11.41,
    width: 2.52,
    height: 25.34,
    transform: "translate(35.13 -32.61) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M21.21,13.41H46.54m0-10.89H21.2M46.54,13.41V12.26l-17.46,0H21.2v1.18M46.54,3.74V2.52H21.2V3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-27",
    points: "46.55 13.41 21.2 13.41 21.2 12.23 46.55 12.26 46.55 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-28",
    points: "46.55 3.74 21.2 3.71 21.2 2.52 46.55 2.52 46.55 3.74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-29",
    x: 33.21,
    y: -12,
    width: 1.34,
    height: 25.33,
    transform: "translate(34.55 -33.21) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-4",
    "data-name": "Left HL",
    className: "cls-30",
    x: 33.29,
    y: 2.73,
    width: 1.18,
    height: 25.33,
    transform: "translate(49.28 -18.48) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "46.55 12.26 46.55 3.74 21.2 3.71 21.2 12.23 46.55 12.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-31",
    points: "46.55 5.04 21.2 5.04 21.2 3.71 46.55 3.74 46.55 5.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-32",
    points: "46.55 10.88 21.2 10.88 21.2 12.23 46.55 12.26 46.55 10.88"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverHorizontalstrip);
export default __webpack_public_path__ + "static/media/silverHorizontalstrip.ad33e8cb13c7df165dd7d8807f6b7c13.svg";
export { ForwardRef as ReactComponent };